import { func, object } from "prop-types"
import { useContext } from "react"
import RegisterableContext from "components/admin/registerable/context"
import { Button, StackView } from "@planningcenter/tapestry-react"
import { StatusMessage } from "components/ui"

const Footer = ({ onCancel, onRegisterSave, onRegisterSaveAndClose, status }) => {
  const { loading, registerable } = useContext(RegisterableContext)

  return (
    <StackView
      axis="horizontal"
      alignment="center"
      distribution="flex-end"
      spacing={2}
      marginBottom={1}
      marginTop={4}
    >
      {status && (
        <div className="mr-1">
          <StatusMessage {...status} />
        </div>
      )}
      <Button title="Cancel" variant="naked" onClick={onCancel} disabled={loading} />
      <Button
        title="Save & close"
        variant="outline"
        onClick={onRegisterSaveAndClose}
        disabled={loading || !registerable.completable}
      />
      <Button
        title="Save"
        theme="create"
        onClick={onRegisterSave}
        disabled={loading || !registerable.completable}
      />
    </StackView>
  )
}

Footer.propTypes = {
  onCancel: func,
  onRegisterSave: func,
  onRegisterSaveAndClose: func,
  status: object
}

export default Footer
